import { log2 } from "../../utils/log2";
import {
    changeDefaultMailAddress,
    changeIsAgentMailVisible,
    changeSignatureAutoUse,
    changeVisibility,
    cleanAllUnreadThread,
    cleanUnreadThread,
    createMailAddress,
    createMailTemplate,
    createVisitorAndMailAddressMulti,
    deleteSenderMail,
    deleteThread,
    deleteThreadMessage,
    getAgentMailVisibility,
    getAllUnreadMailCount,
    getDepartmentMailAndCount,
    getDepartmentMediaList,
    getMailAddressByToList,
    getMailAddressesByInputValue,
    getMailDetails,
    getMailList,
    getMailSignature,
    getMailVisitors,
    getSearchValueMails,
    getSenderMailAddress,
    getSenderMailAddressesByInput,
    getUserEmail,
    getUserMailList,
    getUserMediaList,
    getVisibilityMailAddress,
    getVisibilityUser,
    getVisitorMailList,
    getVisitorsByMailAddress,
    mailVerification,
    saveSignature,
    getDepartmentMailAddresses,
    MAIL_API,
} from "../../api/mail";
import CONFIG from "../../config/config";

const log = log2("mail");
const mail = {
    namespaced: true,
    state: {
        domainIsCreated: false,
        isNewDomain: false,
        isNewUserMail: false,
        isNewDepartment: false,
        allMailAddresses: [],
        selectedMenu: "My",
        selectedDepartment: "",
        selectedMailThreadId: "",
        selectedUserMailThreadId: "",
        exportContent: "",
        exportDesign: {},
        selectedNewMail: false,
        selectedNewTemplate: false,
        emailNotification: false,
        emailSendSuccess: false,
        departmentMailAddresses: [],
        allUnreadMailCounts: 0,
        newCreatedMailId: "",
        newSenderMail: {},
        updateSenderMail: {},
        newForwardMailAddress: {},
        selectedRepresentativeInfo: {},
        selectedMailId: localStorage.getItem("selected-mail-id"),
        selectedTicketMail: localStorage.getItem("selected-ticket-mail-id"),
    },

    getters: {},

    mutations: {
        domainIsCreated(state, payload) {
            state.domainIsCreated = payload.domainIsCreated;
            state.isNewDomain = payload.isNewDomain;
        },
        allMailAddresses(state, payload) {
            state.allMailAddresses = payload;
        },
        updateMailAddress(state, payload) {
            state.updateSenderMail = payload;
        },
        newMailAddress(state, payload) {
            if (!!payload.isNewForwardMailAddress) {
                state.newForwardMailAddress = payload;
            }
            const isMailExist = state.allMailAddresses.filter((mail) => mail._id === payload._id);
            if (isMailExist.length !== 0) {
                state.allMailAddresses = state.allMailAddresses.map((mail) => {
                    if (mail._id === payload._id) {
                        return payload;
                    }
                    return mail;
                });
            } else {
                state.allMailAddresses = [...state.allMailAddresses, payload];
            }
            if (payload.type === "user" && !payload.isForward) {
                state.isNewUserMail = !state.isNewUserMail;
            } else if (payload.type === "department") {
                state.isNewDepartment = !state.isNewDepartment;
            }
        },
        SEND_EMAIL_SUCCESS(state, payload) {
            state.emailSendSuccess = !state.emailSendSuccess;
            state.selectedNewMail = false;
            state.selectedNewTemplate = false;
            /* if (state.selectedMenu === "department") {
                 state.selectedMenu = "department";
             } else {
                 state.selectedMenu = "Sent";
             }
             state.newCreatedMailId = payload._id;
             state.selectedMailThreadId = payload.thread_id;*/
        },
        CHANGE_SELECTED_MENU(state, payload) {
            state.selectedMenu = payload;
            state.selectedNewTemplate = false;
        },
        CHANGE_SELECTED_DEPARTMENT(state, payload) {
            state.selectedDepartment = payload;
            state.selectedNewTemplate = false;
        },
        SELECTED_MAIL(state, payload) {
            state.selectedMailThreadId = payload;
            state.selectedNewMail = false;
            state.selectedNewTemplate = false;
        },
        USER_SELECTED_MAIL(state, payload) {
            state.selectedUserMailThreadId = payload;
            state.selectedNewMail = false;
            state.selectedNewTemplate = false;
        },
        SELECTED_NEW_MAIL(state, payload) {
            state.selectedNewMail = payload;
            state.selectedMailThreadId = "";
            state.selectedNewTemplate = false;
        },
        SELECTED_NEW_TEMPLATE(state, payload) {
            state.selectedNewTemplate = payload;
        },
        changeSelectedRepresentativeInfo(state, payload) {
            state.selectedRepresentativeInfo = payload;
        },
        SET_ALL_UNREAD_MAIL_COUNT(state, payload) {
            state.allUnreadMailCounts = payload;
        },
        CHANGE_EXPORT_CONTENT(state, payload) {
            state.exportContent = payload;
        },
        CHANGE_EXPORT_DESIGN(state, payload) {
            console.log("CHANGE_EXPORT_DESIGN", payload);
            state.exportDesign = payload;
        },
        playEmailNotification(state, payload) {
            state.emailNotification = payload;
        },
        CHANGE_DEFAULT_MAIL(state, payload) {
            state.allMailAddresses = state.allMailAddresses.map((mail) => {
                mail.idDefault = mail._id === payload;
                return mail;
            });
        },
        DELETE_MAIL_ADDRESS(state, payload) {
            state.allMailAddresses = state.allMailAddresses.filter((mail) => {
                if (!!payload.isSenderMail) {
                    return mail._id !== payload._id || mail.forwardTo === payload.mail;
                } else {
                    return mail._id !== payload._id;
                }
            });
        },
        DELETE_SENDER_MAIL_ADDRESSES(state, payload) {
            state.allMailAddresses = state.allMailAddresses.filter(
                (mail) => mail.isSenderMail === false || mail._id !== payload
            );
        },
        addSenderMail(state, payload) {
            state.allMailAddresses = [...state.allMailAddresses, payload];
            state.newSenderMail = payload;
        },
        async saveSelectedMailId(state, mailAddressId) {
            localStorage.setItem("selected-mail-id", mailAddressId);
            state.selectedMailId = mailAddressId;
        },
        async saveSelectedTicketMail(state, mailAddressId) {
            localStorage.setItem("selected-ticket-mail-id", mailAddressId);
            state.selectedTicketMail = mailAddressId;
        },
    },

    actions: {
        async sendEmailSuccess({ commit }, payload) {
            await getMailDetails(payload.thread_id).then((res) => res.data);
            commit("SEND_EMAIL_SUCCESS", payload);
        },
        async getUserMediaList({ commit }, { mailAddressId, pageCount, perPage }) {
            return await getUserMediaList(mailAddressId, pageCount, perPage).then((res) => res.data);
        },
        async getDepartmentMediaList({ commit }, { departmentName, pageCount, perPage }) {
            return await getDepartmentMediaList(departmentName, pageCount, perPage).then((res) => res.data);
        },
        async getMailList({ commit }, { incoming, userId, mailAddress, pageCount, perPage, searchValue }) {
            console.log("getMailList module..", { incoming, userId, mailAddress, pageCount, perPage, searchValue });
            return await getMailList(incoming, userId, mailAddress, pageCount, perPage, searchValue).then(
                (res) => res.data
            );
        },
        async getVisitorMailList({ commit }, payload) {
            return await getVisitorMailList(payload).then((res) => res.data);
        },
        async getUserMailList({ commit }, { userId, mailAddressId, pageCount, perPage, searchValue }) {
            console.log("getUserMailList module..", { userId, mailAddressId, pageCount, perPage });
            return await getUserMailList(userId, mailAddressId, pageCount, perPage, searchValue).then(
                (res) => res.data
            );
        },
        async getMailDetails({ commit }, threadId) {
            return await getMailDetails(threadId).then((res) => res.data);
        },
        async cleanUnreadThread({ commit }, { userId, threadId }) {
            await cleanUnreadThread(userId, threadId).then((res) => res.data);
        },
        async cleanAllUnreadThread({ commit }, userId) {
            await cleanAllUnreadThread(userId).then((res) => res.data);
        },
        async getDepartmentMailAndCount({ commit }, userId) {
            return await getDepartmentMailAndCount(userId).then((res) => res.data);
        },
        async getDepartmentMailAddresses({ commit }, userId) {
            return await getDepartmentMailAddresses(userId).then((res) => res.data);
        },
        async getAllUnreadMailCount({ commit }, userId) {
            if (!CONFIG.EMAIL_SERVICE_ENABLED) return 0;
            const result = await getAllUnreadMailCount(userId).then((res) => res.data);
            commit("SET_ALL_UNREAD_MAIL_COUNT", result);
        },
        async getUserEmailAddress({ commit }, userId) {
            return await getUserEmail(userId).then((res) => res.data);
        },
        async getMailAddressByToList({ commit }, data) {
            return await getMailAddressByToList(data).then((res) => res.data);
        },
        async createVisitorAndMailAddressMulti({ commit }, data) {
            return await createVisitorAndMailAddressMulti(data).then((res) => res.data);
        },
        async getVisitorsByMailAddress({ commit }, data) {
            return await getVisitorsByMailAddress(data).then((res) => res.data);
        },
        async deleteThreadMessage({ commit }, mail) {
            return await deleteThreadMessage(mail).then((res) => res.data);
        },
        async deleteThread({ commit }, threadId) {
            return await deleteThread(threadId).then((res) => res.data);
        },
        async mailVerification({ commit }, { userId, departmentId, mail }) {
            return await mailVerification(userId, departmentId, mail).then((res) => res.data);
        },
        async getMailAddresses({ commit }, { userId, inputValue, selectedMailAddress }) {
            return await getMailAddressesByInputValue(userId, inputValue, selectedMailAddress).then((res) => res.data);
        },
        async getSenderMailAddressesByInput({ commit }, { userId, data }) {
            return await getSenderMailAddressesByInput(userId, data).then((res) => res.data);
        },
        async saveSignature({ commit }, { mailAddress, html }) {
            return await saveSignature(mailAddress, html).then((res) => res.data);
        },
        async getMailSignature({ commit }, { mailAddress }) {
            return await getMailSignature(mailAddress).then((res) => res.data);
        },
        async changeSignatureAutoUse({ commit }, { mailAddress, isAutoAdd }) {
            return await changeSignatureAutoUse(mailAddress, isAutoAdd).then((res) => res.data);
        },
        async changeVisibility({ commit }, { id, mail, visibility }) {
            return await changeVisibility(id, mail, visibility).then((res) => res.data);
        },
        async getVisibilityUser({ commit }, id) {
            return await getVisibilityUser(id).then((res) => res.data);
        },
        async getVisibilityMailAddress({ commit }, userId) {
            return await getVisibilityMailAddress(userId).then((res) => res.data);
        },
        async createMailAddress({ commit }, data) {
            return await createMailAddress(data).then((res) => res.data);
        },
        async getMailVisitors({ commit }, data) {
            return await getMailVisitors(data).then((res) => res.data);
        },
        async getSenderMailAddress({ commit }, data) {
            return await getSenderMailAddress(data).then((res) => res.data);
        },
        async changeDefaultMailAddress({ commit }, payload) {
            await changeDefaultMailAddress(payload).then((res) => res.data);
            commit("CHANGE_DEFAULT_MAIL", payload.mailAddressId);
        },
        async deleteSenderMail({ commit }, mailAddressId) {
            await deleteSenderMail(mailAddressId).then((res) => res.data);
            commit("DELETE_MAIL_ADDRESS", mailAddressId);
        },
        async changeIsAgentMailVisible({ commit }, { userId, visible }) {
            await changeIsAgentMailVisible(userId, visible).then((res) => res.data);
        },
        async getAgentMailVisibility({ commit }, userId) {
            return await getAgentMailVisibility(userId).then((res) => res.data);
        },
        async getAgentsMailAddressList({ commit }) {
            return await MAIL_API.getAgentsEmailAddressList().then((mailAddressList) => {
                commit("allMailAddresses", mailAddressList);
            });
        },
    },
};

export default mail;
